import firebase from "firebase/compat/app"
import "firebase/compat/auth"
import "firebase/compat/firestore"
import "firebase/compat/storage"

const firebaseConfig = {
    apiKey: "AIzaSyCPZQf_dkE96IwmpU7HO1oQUDcf45PsnoA",
    authDomain: "slack-clone-fe99c.firebaseapp.com",
    projectId: "slack-clone-fe99c",
    storageBucket: "slack-clone-fe99c.appspot.com",
    messagingSenderId: "1060312403187",
    appId: "1:1060312403187:web:f3b1a8419a3adfdb5afb86",
    measurementId: "G-N86LZ43N1P"
  };

  firebase.initializeApp(firebaseConfig);
  const db = firebase.firestore();
  const auth = firebase.auth();
  const provider = new firebase.auth.GoogleAuthProvider();
  const storage =firebase.storage();
  
  export { auth,provider,storage};
  export default db;

